import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

function AdminUsersTable({ admins, adjustedHeight, onDeactivate }) {
  if (!admins || admins.length === 0) {
    return <div className="col-span-3 text-gray-500">No results found.</div>;
  }

  return (
    <div
      className="mt-3 overflow-y-auto pr-4 -mr-4"
      style={{ height: `${adjustedHeight}px` }}
    >
      <table className="w-full mt-4">
        <thead>
          <tr className="border-b border-gray-200">
            <th className="text-left py-1 px-1 bg-gray-100 md:table-cell">
              Email
            </th>
            <th className="text-left bg-gray-100">...</th>
          </tr>
        </thead>
        <tbody>
          {admins.map((admin) => (
            <tr
              key={admin.id ?? admin.email}
              className="border-b border-gray-200 hover:bg-blue-50 cursor-pointer"
            >
              <td className="py-2 px-1 md:table-cell text-base">
                {admin.email}
              </td>
              <td>
                {admin.id ? (
                  <FontAwesomeIcon
                    icon={faTimes}
                    className="h-6 text-red-500 cursor-pointer"
                    onClick={() => onDeactivate(admin.id)}
                  />
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AdminUsersTable;
